import { theme } from "@primer/react";
import { colors, typography } from "./tokens";

/**
 * Primer override — clone Old project palette (Bootstrap-style #007bff primary, #c3dcff accent).
 * Bootstrap 5 system font stack (Old project thực tế dùng) cho match SV đã quen + video hướng dẫn.
 */
const lightColors = (theme.colorSchemes?.light as any)?.colors || {};

export const customTheme = {
    ...theme,
    fonts: {
        ...theme.fonts,
        normal: typography.fontFamily,
    },
    fontSizes: ["11px", "12px", "14px", "15px", "16px", "17px", "20px", "24px"],
    radii: ["0px", "2px", "4px", "5px", "12px"],
    colorSchemes: {
        ...theme.colorSchemes,
        light: {
            ...theme.colorSchemes?.light,
            colors: {
                ...lightColors,
                accent: {
                    ...(lightColors.accent || {}),
                    fg: colors.primary,
                    emphasis: colors.primary,
                    muted: colors.primarySubtle,
                    subtle: colors.primarySubtle,
                },
                btn: {
                    ...(lightColors.btn || {}),
                    primary: {
                        ...((lightColors.btn || {}).primary || {}),
                        bg: colors.primary,
                        hoverBg: colors.primaryHover,
                        focusBg: colors.primaryHover,
                        selectedBg: colors.primaryActive,
                        disabledBg: "rgba(0, 123, 255, 0.5)",
                    },
                },
                success: {
                    ...(lightColors.success || {}),
                    fg: colors.success,
                    emphasis: colors.success,
                },
                danger: {
                    ...(lightColors.danger || {}),
                    fg: colors.danger,
                    emphasis: colors.danger,
                },
            },
        },
    },
};
